import { render, staticRenderFns } from "./CooperationSuspended.vue?vue&type=template&id=53d6b3d3&scoped=true&"
import script from "./CooperationSuspended.vue?vue&type=script&lang=js&"
export * from "./CooperationSuspended.vue?vue&type=script&lang=js&"
import style0 from "./CooperationSuspended.vue?vue&type=style&index=0&id=53d6b3d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d6b3d3",
  null
  
)

export default component.exports